import type { RefObject } from 'react'
import { Badge, Group, Paper, Text, UnstyledButton } from '@mantine/core'
import type { ReplySlashItem, SlashMenuUi } from '@/components/tickets/ticket-detail-page-helpers'

type TicketReplySlashMenuProps = {
  slashUi: SlashMenuUi | null
  menuRef: RefObject<HTMLDivElement | null>
  onPick: (item: ReplySlashItem) => void
}

export function TicketReplySlashMenu({ slashUi, menuRef, onPick }: TicketReplySlashMenuProps) {
  if (!slashUi) return null

  return (
    <Paper
      ref={menuRef}
      role="listbox"
      shadow="md"
      withBorder
      p={4}
      style={{
        position: 'fixed',
        left: slashUi.left,
        bottom: slashUi.bottom,
        minWidth: 220,
        maxHeight: 280,
        overflowY: 'auto',
        zIndex: 5000,
      }}
      onMouseDown={(event) => event.preventDefault()}
    >
      {slashUi.filtered.length === 0 ? (
        <Text size="xs" c="dimmed" px="xs" py={6}>
          Нет подходящих шаблонов или макросов
        </Text>
      ) : (
        slashUi.filtered.map((item, index) => (
          <UnstyledButton
            key={`${item.type}-${item.id}`}
            type="button"
            role="option"
            aria-selected={index === slashUi.selectedIndex}
            onClick={() => onPick(item)}
            style={{
              display: 'block',
              width: '100%',
              padding: '8px 10px',
              borderRadius: 4,
              background:
                index === slashUi.selectedIndex
                  ? 'light-dark(rgba(0,0,0,0.06), rgba(255,255,255,0.08))'
                  : undefined,
              textAlign: 'left',
            }}
          >
            <Group justify="space-between" wrap="nowrap" gap={8}>
              <Text size="sm" fw={500} lineClamp={1} style={{ flex: 1 }}>
                {item.shortcut ? `${item.name} (/${item.shortcut})` : item.name}
              </Text>
              <Badge size="xs" variant="light" style={{ flexShrink: 0 }}>
                {item.type === 'template' ? 'Шаблон' : 'Макрос'}
              </Badge>
            </Group>
          </UnstyledButton>
        ))
      )}
    </Paper>
  )
}
